module.exports = __webpack_public_path__ + "static/media/check.0cb63e6e.svg";